class StitchingProduct extends HTMLElement {
    constructor() {
        super();
        this.rechargeLock = false;
        this.lastRechargeKey = null;
        this.switchStitching = this.switchStitching.bind(this);
        this.onPopState = this.onPopState.bind(this);
    }

    connectedCallback() {
        this.container = this.closest('.stitching-products__container');
        this.sectionId = this.container?.getAttribute('data-section-id');

        this.addEventListener('click', this.switchStitching);
    }

    switchStitching() {
        this.handle = this.getAttribute('data-handle');
        this.selectedVariantId = Number(this.getAttribute('data-variant-id'));

        history.pushState(
            { handle: this.handle, variantId: this.selectedVariantId },
            '',
            `${this.handle}?variant=${this.selectedVariantId}`
        );

        this.loadProductFromURL();
    }

    onPopState() {
        this.loadProductFromURL();
    }

    loadProductFromURL() {
        if (!this.sectionId) return;

        const pathname = window.location.pathname;
        const handle = pathname.split('/products/')[1];
        if (!handle) return;

        const params = new URLSearchParams(window.location.search);
        this.selectedVariantId = Number(params.get('variant')) || null;

        this.handle = handle;

        this.fetchProductHTML(handle, this.sectionId).catch(console.error);
    }

    async fetchProductHTML(handle, sectionId) {
        const response = await fetch(
            `${window.location.pathname}?section_id=${sectionId}`
        );

        const html = await response.text();
        this.reRenderProductComponents(html);

        requestAnimationFrame(() => {
            this.initRecharge();
        });
    }

    reRenderProductComponents(html) {
        const mainContainer = document.querySelector('.product');
        if (!mainContainer) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const updatedProduct = parsed.querySelector('.product');
        if (!updatedProduct) return;

        mainContainer.innerHTML = updatedProduct.innerHTML;

        this.currentProductId = this.getProductIdFromDOM();

        if (window.swiperInit) {
            window.swiperInit(
                document.querySelector(`#shopify-section-${this.sectionId}`)
            );
        }
    }

    getProductIdFromDOM() {
        const productJson = document.querySelector('[id^="ProductJson"]');

        if (!productJson) return null;

        try {
            const product = JSON.parse(productJson.textContent);
            return Number(product.id);
        } catch {
            return null;
        }
    }

    initRecharge() {
        if (!window.ReChargeWidget) return;
        if (this.rechargeLock) return;

        const variantId =
            this.selectedVariantId ||
            Number(document.querySelector('[name="id"]')?.value);

        const productId = this.currentProductId;

        if (!variantId || !productId) return;

        const key = `${productId}:${variantId}`;

        if (this.lastRechargeKey === key) return;

        this.rechargeLock = true;
        this.lastRechargeKey = key;

        window.ReChargeWidget.destroyAllWidgets();

        window.ReChargeWidget.createWidget({
            productId,
            variantId,
            injectionParent: 'form[action="/cart/add"]'
        });

        requestAnimationFrame(() => {
            this.rechargeLock = false;
        });
    }

}

if (!customElements.get('stitching-product')) {
    customElements.define('stitching-product', StitchingProduct);
}
